import { Link } from 'react-router-dom';
import { FC, Fragment, memo } from 'react';
import { Breadcrumbs } from '@mui/material';
import { Home } from '@mui/icons-material';
import { useLocation } from 'react-router';

import { TooltipWithPopover } from '../TooltipWithPopover';

import { BreadcrumbsBox, LinkStyled } from './styles';
import { IBeetleBreadcrumbsProps } from './types';

export const BeetleBreadcrumbs: FC<IBeetleBreadcrumbsProps> = memo(({ routes, homeRoute, mobile, sx }) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const currentUrl = window.location.href;
  return (
    <BreadcrumbsBox sx={sx}>
      <Breadcrumbs maxItems={mobile ? 2 : undefined} aria-label='breadcrumb'>
        {homeRoute && (
          <LinkStyled component={Link} to={routes[0].path}>
            <Home fontSize='small' />
          </LinkStyled>
        )}
        {routes
          .filter(({ breadcrumb }) => breadcrumb)
          .map(({ path, breadcrumb }) => {
            const isActive = path === currentPath;
            const linkElement = (
              <LinkStyled component={Link} to={path} underline={isActive ? 'none' : 'always'} color='textPrimary'>
                {breadcrumb}
              </LinkStyled>
            );

            if (isActive) {
              return (
                <TooltipWithPopover
                  key={path}
                  label='Current Link'
                  item={currentUrl}
                  customText='Copy Link'
                  placement='top'
                >
                  {linkElement}
                </TooltipWithPopover>
              );
            }
            return <Fragment key={path}>{linkElement}</Fragment>;
          })}
      </Breadcrumbs>
    </BreadcrumbsBox>
  );
});
